;(function () {

"use strict";

var configureConfigInputTemplate = require('./templates/configure-config-input.html');

var ConfigFormView = Backbone.View.extend({
  initialize: function (opts) {
    opts = opts || {};

    var key = window.unescapedData.key;
    if (!key) {
      key = window.data.key;
    }

    if (opts.objectConfig) {
      this.url = '/objects/config/'+data.type+'/'+encodeURIComponent(key);
      this.redirectUrl = '/objects/config';
    } else {
      this.url = '/config/configure/'+data.type+'/'+encodeURIComponent(key);
      this.redirectUrl = '/config';
    }

    window.App.Events.on('submit', _.bind(this.submit, this));

    var self = this;

    self.resetArrows(this.$el);

    console.log('init configure config form');
  },
  add: function (e) {
    var html;

    html = _.template(configureConfigInputTemplate)();
    $(html).appendTo(this.$el.find('.settings'));

    this.resetArrows();

    return false;
  },
  remove: function (e) {
    var $this = $(e.currentTarget);
    var $section = $this.closest('.settings');

    $this.closest('.form-group').remove();
    this.resetArrows($section);
  },
  generateData: function () {
    var data = [];
    var failed = false;

    this.$el.find('.settings .entry').each(function () {
      var obj = {};
      $(this).find('input').each(function () {
        obj[$(this).attr('name')] = $(this).val();
      });

      if (obj.value && obj.label) {
        data.push(obj);
      } else if (!obj.value && !obj.label) {
        /* Do nothing */
      } else {
        ShopifyApp.Modal.alert({
          title: 'Error',
          message: 'Please fill out both a Label and a Value for all entries and try again.'
        });
        failed = true;
      }
    });

    if (failed) {
      return undefined;
    }

    return data;
  },
  submit: function () {
    var d = {};
    var data = this.generateData();

    if (!data) {
      return;
    }

    if (data.length) {
      d.settings = JSON.stringify(data);
    }

    d.__info__ = this.$el.find('input[name="__info__"]').val();
    d.__folder__ = this.$el.find('input[name="__folder__"]').val();
    d.__delimeter__ = this.$el.find('input[name="__delimeter__"]').val();

    if (this.$el.find('input[name="enableAPI"]:checked')[0]) {
      d.__enableAPI__ = 'true';
    } else {
      d.__enableAPI__ = 'false';
    }

    d.__shop__ = window.data.shop;

    $.post(this.url, d, _.bind(function (d) {
      if (d.status === 'success') {
        this.success(d);
      } else {
        ShopifyApp.Modal.alert({
          title: d.err,
          message: 'Sorry, Something went wrong. Please try this action again or contact jason@thebestagency.com for more help.'
        });
        ShopifyApp.Bar.loadingOff();
      }
    }, this));

    return false;
  },
  success: function (d) {
    var self = this;

    ShopifyApp.Modal.confirm({
      title: 'Success!',
      message: 'Your Configuration has been updated successfully.',
      okButton: 'Close Modal',
      cancelButton: 'Go Back to Configuration',
    }, function (result) {
      if (result) {
        window.location.reload();
      } else {
        ShopifyApp.internalRedirect(self.redirectUrl);
      }
    });
  },
  resetArrows: function ($section) {
    $section = this.$el.find('.settings');
    console.log('resetting arrows');

    var $formGroups = $section.find('.form-group').not('.skip');
    console.log($formGroups[0]);
    $formGroups.find('.move-up, .move-down').attr('disabled', false);
    $formGroups.first().find('.move-up').attr('disabled', 'disabled');
    $formGroups.last().find('.move-down').attr('disabled', 'disabled');
  },
  moveUp: function (e) {
    console.log('moving up');
    var $this = $(e.currentTarget).closest('.form-group');
    $this.insertBefore($this.prev());

    var $section = $this.closest('.settings');
    this.resetArrows($section);
    e.preventDefault();
  },
  moveDown: function (e) {
    console.log('moving down');
    var $this = $(e.currentTarget).closest('.form-group');
    $this.insertAfter($this.next());

    var $section = $this.closest('.settings');
    this.resetArrows($section);
    e.preventDefault();
  },
  events: {
    'click .add': 'add',
    'click .remove': 'remove',
    'click .move-up': 'moveUp',
    'click .move-down': 'moveDown',
    'click .save': 'submit',
    'submit': 'submit'
  }
});

module.exports = ConfigFormView;

}());